import style from './RemoteIcon.css';

export default function RemoteIcon({
  className = '',
  src,
  height = 24,
  width = 24,
}) {
  return (
    <div className={`${className} ${style.container}`}>
      <img src={src} height={height} width={width} />
    </div>
  );
}
